import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/ui/PageHeader';
import Icon from '../../components/ui/Icon';

const CARDS = [
  {
    to: '/resultado',
    icon: 'resultado',
    titulo: 'Resultado',
    desc: 'Lucro, custos e produtividade da safra',
  },
  {
    to: '/relatorios/producao',
    icon: 'producao',
    titulo: 'Produção',
    desc: 'Cargas por período, armazém, safra e área',
  },
  {
    to: '/relatorios/comparar-areas',
    icon: 'comparar-areas',
    titulo: 'Comparar áreas',
    desc: 'Talhão × talhão na mesma safra',
  },
  {
    to: '/relatorios/comparar-safras',
    icon: 'comparar-safras',
    titulo: 'Comparar safras',
    desc: 'Safras da mesma cultura lado a lado',
  },
  {
    to: '/relatorios/custos-lavoura',
    icon: 'manejo',
    titulo: 'Custos por lavoura',
    desc: 'Gastos e aplicações de uma área, por período e categoria',
  },
];

export default function RelatoriosHome() {
  return (
    <div>
      <PageHeader
        titulo="Relatórios"
        icone="relatorio"
        descricao="Análise da fazenda: resultado financeiro, produção e comparações entre áreas e safras."
      />

      <div className="atalho-grid">
        {CARDS.map((c) => (
          <Link key={c.to} to={c.to} className="atalho">
            <span className="atalho-icone"><Icon nome={c.icon} tamanho={24} /></span>
            <span className="atalho-label">{c.titulo}</span>
            <span className="atalho-desc">{c.desc}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
